
$(document).on("click",'.Mobile_nav_trigger',function() {
    if ($('.Mobile_nav_trigger #check').is(":checked")){
        console.log('Checked');
        $('.Mobile_header_overlay').toggleClass('active');
        $('.Mobile_header_nav_outer').toggleClass('active');
        $('body').toggleClass('Overflow_hidden');
    }
}); 

$('.has_child_items_js').mouseover(function(){
    $('.Header_menu_child_container_outer').slideDown();
});

$('.not_has_child_items_js').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.Index_hero_outer').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.Header_menu_child_container_outer').mouseleave(function() {
    // $('.Header_menu_child_container_outer').slideUp();
    // Get the ".has_child_items_js" element
    const hasChildItemsElement = $('.has_child_items_js');

    // Check if the mouse is currently over the ".has_child_items_js" element
    if (hasChildItemsElement.is(':hover')) {
        return; // Do nothing if the mouse is over ".has_child_items_js"
    }

    // If the mouse is not over ".has_child_items_js", slide up the ".Header_menu_child_container_outer" element
    $('.Header_menu_child_container_outer').slideUp();
});

$('.mobile_has_child_items').click(function(){
    $('.Mobile_main_item').removeClass('active');
    $(this).toggleClass('active');
    $(this).parent('div').parent('div').find('.Mobile_inner_child_nav').slideToggle();
});
